import {AudioPrompt} from './AudioPrompt';
import {Continent} from './Continent';
import {Discoverable} from './Discoverable';
import {Gender} from './Gender';
import {Goal} from './Goal';
import {Id} from './Model';
import {UserLocation} from './UserLocation';

export type User = Id &
  UserLocation &
  Discoverable & {
    about?: string;
    about_lang?: string;
    age?: number;
    audio_prompt?: AudioPrompt;
    avatar_urls?: string[];
    avatars: number[];
    continent?: Continent;
    dob?: string; //DD.MM.YYYY
    email?: string;
    first_name: string;
    gender: Gender;
    goal: Goal;
    interests?: number[];
    lang: string;
    new_here?: boolean;
    nickname: string;
    phone?: string;
    school?: string;
    timezone_offset?: number;
    tr_lang: string;
    verified: boolean;
    work?: string;
  };

export function getUserLangCorrected(user: User): string {
  if (user.lang === 'ua') {
    // on backend side we named our lang with wrong codes
    return 'uk';
  }
  return user.lang;
}

type UserId = {
  user_id?: number;
};

export function findByUserId<T extends UserId>(
  userId: number,
  list: T[],
): T | undefined {
  for (const item of list) {
    if (item.user_id === userId) {
      return item;
    }
  }
}

export function isFirstNameSaveable(firstName: string): boolean {
  return firstName.trim().length > 0;
}

export function isFirstNameValid(name: string): boolean {
  const reg = /^[^0-9!@#$%^&*()_+{}\[\]:;<>,.?~\/\p{P}\p{S}\p{M}\p{N}\p{C}]*$/u;
  try {
    return reg.test(name);
  } catch {
    return true;
  }
}

export function userNameAndAge(user: User): string {
  let result = user.first_name;
  if (user.age) {
    result += ', ' + user.age;
  }
  return result;
}

export function userAvatarsLength(user: User): number {
  if (user.avatar_urls) {
    return user.avatar_urls.length;
  }
  return user.avatars.length;
}

export function userLogin(user: User): string | undefined {
  return user.email || user.phone;
}
